import {APIError} from 'data/errors/api-error';
import {HttpClient, HttpStatusCode} from 'data/protocols/http';

import {
  DeleteFavoritePlace,
  DeleteFavoritePlaceRequest,
  DeleteFavoritePlaceResponse,
} from 'domain/usecases';

export class RemoteDeleteFavoritePlace implements DeleteFavoritePlace {
  constructor(
    private readonly url: string,
    private readonly httpClient: HttpClient<DeleteFavoritePlaceResponse>,
  ) {}

  async delete(params: DeleteFavoritePlaceRequest): Promise<DeleteFavoritePlaceResponse> {
    const {signal} = params;

    const httpResponse = await this.httpClient.request({
      url: this.url,
      method: 'delete',
      signal,
    });

    switch (httpResponse.status) {
      case HttpStatusCode.ok:
        return httpResponse.data;
      case HttpStatusCode.created:
        return httpResponse.data;
      case HttpStatusCode.noContent:
        return httpResponse.data;
      default:
        throw new APIError(httpResponse.status, httpResponse.data);
    }
  }
}
